import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import * as CryptoJS from 'crypto-js';
import { CustomValidators } from "../../../../core/custom-validator/custom-validators";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../../providers/user.service";
import { MessageService } from "primeng/api";
import { environment } from "../../../../../environments/environment";
import { CommonService } from "../../../../providers/common.service";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "src/app/providers/auth.service";
import { isEmpty } from "lodash";

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.scss"],
  providers: [MessageService],
})
export class PasswordResetComponent implements OnInit {
  public resetForm: UntypedFormGroup;
  displayBasic: boolean;
  queryParams = {};
  isLoading:boolean = false;
  defaultURL = environment?.defaultLogo;
  loginLogo:any
  tagName:any
  imageUrl = environment.whitelabelLogoPath;
  public formError: any = {};
  showHidePassword:boolean;
  showHideConfirmPassword:boolean;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private messageService: MessageService,
    public commonService: CommonService,
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,

  ) {
    //console.log(this.route.snapshot.queryParams);
  }

  ngOnInit(): void {
    this.authService.defaultTheme(); 
    let whitelabelResData = JSON.parse(localStorage.getItem('whitelabelResData'));
    if (!isEmpty(whitelabelResData)) {
      this.loginLogo = `${this.imageUrl}/${whitelabelResData.logo_Login}`
      this.tagName = whitelabelResData.tagName
    }
    this.route.queryParams.subscribe((params) => {
      this.queryParams = params;
    });
    this.resetForm = this.createForgotPasswordForm();
    this.resetForm.get('password')?.valueChanges.subscribe(() => {
    this.resetForm.get('cpassword')?.updateValueAndValidity({ onlySelf: true });
  });
  }

  createForgotPasswordForm(): UntypedFormGroup {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/;
    return this.formBuilder.group(
      {
        password: [
          "",
          [
            Validators.required,
            CustomValidators.EnhancedPatternValidator(),
            // this.consecutiveCharactersValidator()
          ],
        ],
        cpassword: ["", [Validators.required]],
      },
      { validators: CustomValidators.PassswordMatch }
    );
  }
  getPasswordErrorMessage(): string | null {
    const errors = this.resetForm.get('password')?.errors;
    
    if (!errors) return null; 
    const errorMessages: { [key: string]: string } = {
      required: "Password is required.",
      minLengthError: "Password must be at least 12 characters long.",
      missingUppercase: "Password must contain at least one uppercase letter.",
      missingLowercase: "Password must contain at least one lowercase letter.",
      missingNumber: "Password must contain at least one number.",
      missingSpecialCharacter: "Password must contain at least one special character.",
    };

    for (const key of Object.keys(errorMessages)) {
      if (errors[key]) {
        return errorMessages[key]; 
      }
    }
    return null;
  }


  onFormSubmit() {
    if (!this.resetForm.valid) {
      this.validateAllFields(this.resetForm);
      //this.showSuccessDialog();
    } else {
      this.passwordReset(this.resetForm.value, this.queryParams);
      this.isLoading = true;
    }
  }

  validateAllFields(form: UntypedFormGroup) {
    Object.keys(form.controls).forEach((field) => {
      const control = form.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  passwordReset(resetForm, queryParams) {
    if (
      this.queryParams &&
      Object.keys(this.queryParams).length === 0 &&
      this.queryParams.constructor === Object
    ) {
      let errMsg = {
        status: "Unauthorized Access",
        message: "You do not have permission to reset password",
      };

      this.showAlert(errMsg, "error");
    } else {
      let encryptedPassword = this.encryptPassword(resetForm.password);
      let encryptedConfirmPassword = this.encryptPassword(resetForm.cpassword);
      resetForm.password = encryptedPassword;
      resetForm.cpassword = encryptedConfirmPassword;
      let formData = {
        ...resetForm,
        ...queryParams,
      };
      this.userService.resetPassword(formData).subscribe(
        (res) => {
          // this.showAlert(
          //   { status: "Success!", message: res.message },
          //   "success"
          // );
          //

          this.showSuccessDialog();
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          if (err?.type == 'MODAL') {
            this.authService.showModal(err);
          } else {
            this.showAlert(err, "error");
          }
        }
      );
    }
  }

  encryptPassword(password) {
    return CryptoJS.AES.encrypt(password, this.commonService.getAccountPersonalData('pstwd')).toString();
  }

  decryptPassword(password) {
    return CryptoJS.AES.decrypt(password, this.commonService.getAccountPersonalData('pstwd')).toString(CryptoJS.enc.Utf8);
  }

  goToLogin() {
    this.displayBasic = false;
    this.isLoading = false;
    this.router.navigate(["/auth/login"]);
  }

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
      life: 5000,
    });
  }

  showSuccessDialog() {
    this.displayBasic = true;
  }
  showpassword(){
    this.showHidePassword = !this.showHidePassword;
  }
  showconfirmpassword(){
    this.showHideConfirmPassword = !this.showHideConfirmPassword;
  }
}
